import { TVs } from "tonva-react";
import { common } from "./common";
import { warehouse } from "./warehouse";
import { product } from "./product";
import { order } from "./order";
import { customer } from './customer';

export const tvs:TVs = {
    common: common,
    warehouse: warehouse,
    product: product,
    order: order,
    customer: customer,
}